module.exports = __webpack_public_path__ + "static/3.1-f4c33663c648e87c1cf980bb78d8b637.jpg";